<template>
  <div id="manyidu" class="">
    <el-container>
      <div>
        <div class="bg-image"></div>
        <div style="margin:140px 100px;">
          <div class="question">
            <div class="item">
              <el-row :gutter="60">
                <el-col :span="6">
                  <img src="../assets/images/wang.png" alt="" style="width:100%">
                </el-col>
                <el-col :span="18">
                  <div>
                    <h3 class="title">王冬老师（Leon Wang）</h3>
                    <div class="subtitle">王冬老师拥有15年以上的人力资源从业经历。曾历任托马斯国际大中华区项目总监和销售总监、太和顾问副总裁业务发展总监，BATJ两家公司培训和人才发展部门总监工作，管理过400人的团队。潜心研究competence、assessment center、development的CAD三角解决方案，同时做为专职讲师服务各大型企业。</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="item">
              <el-row :gutter="60">
                <el-col :span="6">
                  <img src="../assets/images/fang.png" alt="" style="width:100%">
                </el-col>
                <el-col :span="18">
                  <div>
                    <h3 class="title">方南老师</h3>
                    <div class="subtitle">高绩效管理/领导模式研究专家; 经营管理效能与商业模式研究专家; 中国管理研究院管理绩效研究所所长;近20年企业实践；10余年企业高管，培训数千场，被素有“培训行业的奥斯卡”之称的“前沿金坛奖”组委会评为“2010年度全国十大人气讲师”称号。</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="item">
              <el-row :gutter="60">
                <el-col :span="6">
                  <img src="../assets/images/he.png" alt="" style="width:100%">
                </el-col>
                <el-col :span="18">
                  <div>
                    <h3 class="title">何欣老师</h3>
                    <div class="subtitle">15年世界500强从业经历，负责过多家国内外上市公司的企业大学筹建及日常管理工作。在坚持培训要“有用”的思想基础上，致力于企业大学的客户化经营、专业化生存、项目化运作，打造“人才发展+问题解决”一体两翼的组织运营模式。</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="item">
              <el-row :gutter="60">
                <el-col :span="6">
                  <img src="../assets/images/chen.png" alt="" style="width:100%">
                </el-col>
                <el-col :span="18">
                  <div>
                    <h3 class="title">陈慧颖老师</h3>
                    <div class="subtitle">全球华人讲师会五星级讲师；北京培训行业联合会常务理事；清华大学研究生院特聘讲师；中国人民大学培训学院特聘讲师；获2013年度“最佳实战型管理技能讲师”荣誉称号（搜狐职场一言堂、京培联、《企业大学》杂志、智慧中国联盟联合评选）；15年的企业管理实战经验，专注于：管理者的“执行艺术”、“ 领导艺术”及“打造高效的团队合作”等课程。</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="item">
              <el-row :gutter="60">
                <el-col :span="6">
                  <img src="../assets/images/zhang.png" alt="" style="width:100%">
                </el-col>
                <el-col :span="18">
                  <div>
                    <h3 class="title">张敏老师介绍</h3>
                    <div class="subtitle">首都经济贸易大学人力资源硕士研究生，法学学士，WFA国际促动师协会认证催化师，埃里克森ICF教练，PPA（托马斯）测评全球认证讲师，TEI情商测试全球认证讲师，美国经理人协会认证专业培训师。兼具教练、引导师、培训师三重角色。</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="item">
              <el-row :gutter="60">
                <el-col :span="6">
                  <img src="../assets/images/wangfei.png" alt="" style="width:100%">
                </el-col>
                <el-col :span="18">
                  <div>
                    <h3 class="title">王飞老师</h3>
                    <div class="subtitle">《精准销售模式》研发者（版权所有者）；《有效管理》课程研发者（版权所有者）；原伊利集团冷饮销售系统全国培训经理；独立研发五门版权课程（经过中国版权保护中心审核）和一套教学模式。</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="question">
            <el-row :gutter="60">
              <el-col :span="8" v-for="kecheng in lists" :key="kecheng.id">
                <div class="video-item">
                  <div style="position:relative">
                    <img :src="kecheng.cover" alt="" class="video-img">
                    <img src="../assets/icons/play.png" alt="" class="play-icon" @click="gotoVideoDetail(kecheng.id,kecheng.try_and_see_url)">
                  </div>
                  <div style="padding:20px;font-size:14px;font-weight:900">{{ kecheng.title }}</div>
                  <div style="padding:0 20px 20px 20px;"><span style="color:#ff0000;font-size:14px">售价￥{{ kecheng.price/100 }}元</span></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
import helpers from '../helper'
export default {
  name:'manyidu',
  data(){
    return {
      lists:[]
    }
  },
  methods:{
    gotoVideoDetail(vid,cover){
      this.$router.push({path:'/kechengxiangqing', query:{vid:vid}})
    }    
  },
  mounted(){
    let _this = this
    this.$http.get(helpers.BASE_URL + '/api/home/index/getKecheng')
    .then(function(response){
      if(response.data.code === 1 ){
        console.log(response.data.data)
        _this.lists = response.data.data
      }
    })
    .catch(function (error) {
      //console.log(error);
    });
  }
}
</script>
<style scoped>
.home{
  background-color: #f4f4f4;
  width: 100%;
}
.bg-image{
  background-image: url('../assets/images/bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  overflow: hidden;
  width: 100%;
  height: 100vh;  
}
.subtitle{
  margin-top: 40px;
  line-height: 1.5;
  text-align: justify;
}
.item{
  margin-bottom: 100px;
}
.video-img{
  width: 100%;
  height: 200px;
}
.video-item{
  margin-bottom: 80px;
  border: 1px solid #bbbbbb;
}
.play-icon{
  position: absolute;
  width: 60px;
  top: 40%;
  left: 40%;
  cursor: pointer;
  transition: all ease-in .3s;
}
.play-icon:hover{
  transform:scale(1.1);
}
</style>
